var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"calc-error"},[_c('div',{staticClass:"calc-error__container"},[_c('span',[_vm._v("Внутренняя ошибка сервера")]),_c('button',{on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("ок")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }